'use client';

import { Typography } from 'components';
import { get } from 'lodash';
import { useTranslations } from 'next-intl';
import { useDeveloperLogs } from 'providers/IntegrationsProvider/useDeveloperLogs';
import { Fragment, useEffect } from 'react';
import { connect } from 'react-redux';
import DownloadLogs from './DownloadLogs';
import Filters from './Filters';
import { loadMoreLogs } from './_actions';

const Log = ({ currentPage, filters, loadMoreLogs }) => {
  const t = useTranslations();
  const {
    data: { pages } = {},
    isLoading,
    fetchNextPage
  } = useDeveloperLogs(
    {
      page: currentPage,
      ...filters
    },
    {
      getNextPageParam: (_lastPage, _allPages) => currentPage
    }
  );

  useEffect(() => {
    fetchNextPage();
  }, [currentPage]);

  if (isLoading) return null;

  const pagesCount = get(pages, [0, 'developerLogs', 'pagesCount']);

  return (
    <div className="legacy">
      <Typography variant="medium7xl" className="!mb-8 !mt-0 flex text-tertiary-100">
        {t('integrations.logs.log.logs')}
      </Typography>
      <div className="developers__logs">
        <Filters>{!!pages?.length && <DownloadLogs />}</Filters>
        <div className="developers__console">
          {pages?.length > 0 ? (
            <div>
              <ul className="developers__console__logs">
                {pages.map((page, index) => (
                  <Fragment key={`page-${index}`}>
                    {page.developerLogs.nodes.map((log) => (
                      <li key={log.id} className={`developers__console__logs--${log.level}`}>
                        <span className="developers__console__logs__level">{log.level}</span>
                        <span className="developers__console__logs__date">{log.createdAt}</span>
                        <span className="developers__console__logs__message">{log.message}</span>
                      </li>
                    ))}
                  </Fragment>
                ))}
              </ul>

              {currentPage < pagesCount ? (
                <button
                  className="developers__console__logs__load_more"
                  onClick={() => {
                    loadMoreLogs(currentPage + 1);
                  }}
                  disabled={isLoading}
                >
                  {t('integrations.logs.log.load_more')}
                </button>
              ) : (
                ''
              )}
            </div>
          ) : (
            <span className="flex flex-col text-5xl font-medium">
              <span className="developers__no_requests">
                {t('integrations.logs.log.none_found')}
              </span>
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default connect(({ currentPage, filters }) => ({ currentPage, filters }), { loadMoreLogs })(
  Log
);
